<template>
  <v-app>
    <AdminSidebar />

    <v-app-bar app flat dense clipped-left>
      <v-app-bar-nav-icon @click.stop="$root.drawer = !$root.drawer" />
      <v-toolbar-title>{{ $root.appTitle }}</v-toolbar-title>
      <v-spacer />
      <v-img contain src="/img/T_logo.png" height="39px" max-width="200px" />
      <v-img
        contain
        src="/img/logo_nwt_new.png"
        height="56px"
        max-width="200px"
      />
      <v-toolbar-items>
        <NotificationsMenu />
        <UserMenu />
      </v-toolbar-items>
    </v-app-bar>
    <v-main class="background">
      <Subbar />
      <v-container class="px-6 my-6" fluid>
        <Alert dismissible />
        <flash-messages />
        <slot />
      </v-container>
    </v-main>
    <Footer />
  </v-app>
</template>

<script>
import AdminSidebar from '@/Components/Layout/AdminSidebar'
import Subbar from '@/Components/Layout/Subbar'
import Footer from '@/Components/Layout/Footer'
import UserMenu from '@/Components/Layout/UserMenu'
import NotificationsMenu from '@/Components/Layout/NotificationsMenu'

export default {
   name: 'MainLayout',
   components: {
      AdminSidebar,
      Subbar,
      Footer,
      UserMenu,
      NotificationsMenu
   },

   data: () => ({
      drawer: true,
      user: null
   }),
   created () {
      this.user = this.$page.props.user
   },
   methods: {
      //
   }
}
</script>
